module.exports = __webpack_public_path__ + "img/android-contact.e9830f98.png";